import { render, staticRenderFns } from "./create-cate.vue?vue&type=template&id=470a1175&"
import script from "./create-cate.vue?vue&type=script&lang=ts&"
export * from "./create-cate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-cate.vue"
export default component.exports